import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-shield-check-line', title: 'Tam Hasar Kapsamı', desc: 'Kargo gönderilerinde meydana gelebilecek olan hasarda gönderi ücretinin zararının tazmin edilmesini sağlıyoruz.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Risk Yönetimi', desc: 'Değerli gönderilerinizi Cargo Team aracılığı ile sigorta ettirerek riskinizi en az indirebilirsiniz.' },
  { icon: 'ri-global-line', title: 'Uluslararası Kapsam', desc: 'Tüm uluslararası gönderileriniz için sigorta hizmeti sunuyoruz.' },
  { icon: 'ri-file-list-3-line', title: 'Kolay Başvuru', desc: 'Sigorta başvurunuzu kolayca yapın, uzman ekibimiz tüm süreci sizin adınıza yönetsin.' },
  { icon: 'ri-customer-service-2-line', title: 'Uzman Destek', desc: 'Sigorta süreçlerinde uzman ekibimiz her adımda yanınızda, sorularınızı anında yanıtlıyoruz.' },
  { icon: 'ri-lock-line', title: 'Güvenceli Taşıma', desc: 'Tüm gönderileriniz sigorta güvencesi altında taşınır, değerli ürünleriniz korunur.' },
];

const coverageItems = [
  { icon: 'ri-box-3-line', label: 'Hasar & Kırılma' },
  { icon: 'ri-delete-bin-line', label: 'Kayıp & Çalınma' },
  { icon: 'ri-water-flash-line', label: 'Su Hasarı' },
  { icon: 'ri-fire-line', label: 'Yangın Hasarı' },
  { icon: 'ri-truck-line', label: 'Taşıma Kazaları' },
  { icon: 'ri-time-line', label: 'Gecikme Tazminatı' },
];

export default function SigortaPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=protective%20shield%20concept%20over%20cargo%20packages%2C%20insurance%20and%20security%20visualization%2C%20glowing%20protective%20dome%20over%20shipping%20boxes%2C%20dark%20dramatic%20background%20with%20orange%20and%20amber%20light%20rays%2C%20safety%20and%20protection%20concept%2C%20cinematic%20digital%20art%20style&width=1920&height=680&seq=sigorta-hero-01&orientation=landscape"
            alt="Sigorta"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Sigorta</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-shield-check-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Sigorta</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Gönderileriniz<br />
                <span style={{ color: 'var(--orange)' }}>Güvence Altında</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Kargo gönderilerinde meydana gelebilecek hasarda zararın tazmin edilmesini sağlıyoruz. Değerli gönderilerinizi sigorta ettirerek riskinizi minimize edin.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[{ val: 'Tam', lbl: 'Kapsam' }, { val: 'Risk', lbl: 'Yönetimi' }, { val: 'Global', lbl: 'Geçerlilik' }, { val: '7/24', lbl: 'Destek' }].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Coverage */}
      <section className="py-16" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--text1)' }}>Sigorta Kapsamı</h2>
            <p className="text-sm" style={{ color: 'var(--text3)' }}>Gönderileriniz bu risklere karşı güvence altındadır.</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {coverageItems.map((c, i) => (
              <div key={i} className="flex flex-col items-center gap-3 p-5 rounded-2xl text-center" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${c.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <span className="text-xs font-semibold" style={{ color: 'var(--text2)' }}>{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Sigorta Hizmeti</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Kargo gönderilerinde meydana gelebilecek olan hasarda gönderi ücretinin zararının tazmin edilmesini sağlayan işlemdir. Değerli gönderilerinizi Cargo Team aracılığı ile sigorta ettirerek riskinizi en az indirebilirsiniz.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Tüm uluslararası gönderileriniz için kapsamlı sigorta hizmeti sunuyoruz. Uzman ekibimiz sigorta süreçlerini sizin adınıza yönetir.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=insurance%20agent%20reviewing%20cargo%20claim%20documents%2C%20professional%20risk%20assessment%20meeting%2C%20secure%20office%20environment%2C%20warm%20professional%20lighting%2C%20trust%20and%20reliability%20concept%2C%20business%20insurance%20photography%2C%20clean%20modern%20office&width=420&height=280&seq=sigorta-content-01&orientation=landscape"
                alt="Sigorta hizmeti"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Sigorta Hizmeti İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Gönderilerinizi güvence altına almak için hemen iletişime geçin.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
